import { CartItems } from '@/scripts/cart/cart-items'
import {getAttributeOrThrow, SELECTORS} from '@/scripts/core/global';

export class CartDrawerItems extends CartItems {
	static override htmlSelector = 'cart-drawer-items'
	static override selectors = {
		...CartItems.selectors,
		element: 'cart-drawer-items',
		lineItemStatus: '[data-uc-cart-drawer-status]',
		errors: '[data-uc-cart-drawer-errors]',
		liveRegionText: '[data-uc-cart-drawer-live-region-text]',
		main: '[data-uc-cart-drawer-main]',
		// the following selectors are partial - they will be concatenated with the line ID
		line: '#CartDrawer-Item', // ex: `${this.instanceSelectors.line}-${line}`
		lineQuantity: '#CartDrawer-Quantity', // ex: `${this.instanceSelectors.lineQuantity}-${line}`
		lineError: '#CartDrawer-LineItemError', // ex: `${this.instanceSelectors.lineError}-${line}`
	}
	altSectionId?: string
	constructor() {
		super();
		if (this.hasAttribute('data-uc-cart-drawer-items-section-id')) {
			this.altSectionId = getAttributeOrThrow('data-uc-cart-drawer-items-section-id', this)
		}
	}
	override setInstanceSelectors() {
		this.instanceSelectors = CartDrawerItems.selectors
	}
	override getSectionsToRender() {
		const cartDrawerSectionId = this.altSectionId ?? 'cart-drawer'
		return [
			{
				id: 'CartDrawer',
				section: cartDrawerSectionId,
				selector: this.instanceSelectors.cartDrawerInner,
			},
			{
				id: 'CartIconBubble',
				section: 'cart-icon-bubble',
				selector: SELECTORS.cartLink,
			},
		]
	}
}
